import { useEffect } from "react";
import { useToasts } from "react-toast-notifications";
import { useDispatch, useSelector } from "react-redux";
import { getNotification } from "store/selectors";
import { resetNotification } from "store/actionCreators/notification";

const Notification = () => {
  const { addToast } = useToasts();
  const dispatch = useDispatch();
  const notification = useSelector(getNotification);

  useEffect(() => {
    if (notification.message) {
      addToast(notification.message, { appearance: notification.appearance });
      setTimeout(() => {
        dispatch(resetNotification());
      }, 3500);
    }
  }, [notification]);

  return false;
};

export default Notification;
